/** 清空所有在用session */
export const cleanSessions = () => {
  sessionStorage.removeItem("SUBSIDY_STEP_1")
  sessionStorage.removeItem("TITLESERVICE_STEP_1")
  sessionStorage.removeItem("TITLESERVICE_STEP_2")
  sessionStorage.removeItem("TITLESERVICE_STEP_3")
  sessionStorage.removeItem("TITLESERVICE_STEP_4")
  sessionStorage.removeItem("UPLOAD")
}
